import { render, staticRenderFns } from "./closeDialog.vue?vue&type=template&id=55212642&scoped=true"
import script from "./closeDialog.vue?vue&type=script&lang=js"
export * from "./closeDialog.vue?vue&type=script&lang=js"
import style0 from "./closeDialog.vue?vue&type=style&index=0&id=55212642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55212642",
  null
  
)

export default component.exports